import React, { useEffect, useRef, useState } from 'react';
import { StoreConsumptionService } from '@gtpl/shared-services/procurement';
import './store-consumption-grid.css';
import { GetStoreConsumptionItemsDto, StoreConsumptionDetails, StoreConsumptionItemsDto, StoreConsumptionStatus } from '@gtpl/shared-models/procurement-management';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Input, Button, Divider, Popconfirm, Switch, Tag, Card, Col, Drawer, Row, Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import { CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EyeOutlined, EditOutlined, SearchOutlined, SnippetsOutlined } from '@ant-design/icons';
import Table, { ColumnProps } from 'antd/lib/table';
import { Link, Redirect } from 'react-router-dom';
import moment from 'moment';
import StoreConsumptions from './store-consumption-detail-view';
import { EmployeeRolesEnum, UnitRequest } from '@gtpl/shared-models/common-models';
const { TabPane } = Tabs;

/* eslint-disable-next-line */
export interface StoreConsumptionGridProps { }

export function StoreConsumptionGrid(
  props: StoreConsumptionGridProps
) {

  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [redirectToReturn, setRedirectToReturn] = useState(false);
  const [returnData, setReturnData] = useState(undefined);
  const [storeConsumptionData, setStoreConsumptionData] = useState<StoreConsumptionDetails[]>([]);
  const [cancelledSoConsumptions, setCancelledSoConsumptions] = useState<StoreConsumptionDetails[]>([]);
  const [revisedSoConsumptions, setRevisedSoConsumptions] = useState<StoreConsumptionDetails[]>([]);

  const [selectedDepartmentData, setSelectedDepartmentData] = useState<any>(undefined);
  const [storeConsumptionId, setStoreConsumptionId] = useState<number>(0);

  const storeConsumptionService = new StoreConsumptionService();

  useEffect(() => {
    getAllStoreConsumptionDetails();
    getAllCancelledSosStoreConsumptions();
    getAllRevisedSosStoreConsumptions();
    // getAllStoreConsumptionItemDetails();
  },[]);

  /**
   * 
   */
  const getAllStoreConsumptionDetails = () => {
    const req = new UnitRequest(Number(localStorage.getItem('unit_id')), JSON.parse(localStorage.getItem('role')));
    storeConsumptionService.getAllStoreConsumptionDetails(req).then(res => {
      console.log(res.data);
      if (res.status) {
        setStoreConsumptionData(res.data);
      } else {
        if (res.intlCode) {
          setStoreConsumptionData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setStoreConsumptionData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getAllCancelledSosStoreConsumptions = () => {
    const req = new UnitRequest(Number(localStorage.getItem('unit_id')), JSON.parse(localStorage.getItem('role')));
    storeConsumptionService.getAllCancelledSosStoreConsumptions(req).then(res => {
      console.log(res.data);
      if (res.status) {
        setCancelledSoConsumptions(res.data);
      } else {
        if (res.intlCode) {
          setCancelledSoConsumptions([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setCancelledSoConsumptions([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getAllRevisedSosStoreConsumptions = () => {
    const req = new UnitRequest(Number(localStorage.getItem('unit_id')), JSON.parse(localStorage.getItem('role')));
    storeConsumptionService.getAllRevisedSosStoreConsumptions(req).then(res => {
      console.log(res.data);
      if (res.status) {
        setRevisedSoConsumptions(res.data);
      } else {
        if (res.intlCode) {
          setRevisedSoConsumptions([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setRevisedSoConsumptions([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  // const getAllStoreConsumptionItemDetails = () => {
  //   storeConsumptionService.getAllStoreConsumptionItemDetails().then(res => {
  //     console.log(res.data);
  //     if (res.status) {
  //       setStoreConsumptionItemsData(res.data);
  //     } else {
  //       if (res.intlCode) {
  //         setStoreConsumptionItemsData([]);
  //         AlertMessages.getErrorMessage(res.internalMessage);
  //       } else {
  //         AlertMessages.getErrorMessage(res.internalMessage);
  //       }
  //     }
  //   }).catch(err => {
  //     setStoreConsumptionItemsData([]);
  //     AlertMessages.getErrorMessage(err.message);
  //   })
  // }
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });
  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
  const closeDrawer = () => {
    setDrawerVisible(false);
  }

  //TO open the form for updation
  const openFormWithData = (viewData: StoreConsumptionDetails) => {
    setDrawerVisible(true);
    setSelectedDepartmentData(viewData);
    console.log(selectedDepartmentData)
    console.log('selectedDepartmentData')
  }
  const gotToStoreIssuesDetailView = (rowData: { storeConsumptionId: number; }) => {
    setStoreConsumptionId(rowData.storeConsumptionId);
    console.log(storeConsumptionId);
  }
  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      align: 'left',
      render: (text, object, index) => (page - 1) * 10 + (index + 1)
    },
    {
    title:'Prod Unit',
    dataIndex:'unitId',
    width:180,
    filters: [
      {
        text: 'Unit 1',
        value: 'Unit 1',
      },
      {
        text: 'Unit 2',
        value: 'Unit 2',
      },
      {
        text: 'Kakinada',
        value: 'Kakinada',
      },
    ],
    filterMultiple: false,
    onFilter: (value, record) => {
      return record.unitId == value;
    },
    },
    {
      title: 'Store Consumption Code',
      dataIndex: 'storeConsumptionCode',
      width: 180,
      align: 'left',
      sorter: (a, b) => a.storeConsumptionCode.localeCompare(b.storeConsumptionCode),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('storeConsumptionCode')
    },


    {
      title: 'Customer PO',
      dataIndex: 'saleOrder',
      align: 'left',
      width: 200,
      sorter: (a, b) => a.saleOrder.localeCompare(b.saleOrder),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('saleOrder')
    },
    {
      title: 'Customer',
      dataIndex: 'endCustomerName',
      align: 'left',
      width: 200,
      sorter: (a, b) => a.endCustomerName.localeCompare(b.endCustomerName),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('endCustomerName')
    },

    {
      title: 'Consumed Date',
      dataIndex: 'consumedDate',
      width: 150,
      align: 'left',
      sorter: (a, b) => moment(a.consumedDate).unix() - moment(b.consumedDate).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => { return moment(record.consumedDate).format('YYYY-MM-DD') },

      // ...getColumnSearchProps('consumedDate')
    },
    {
      title: 'Indent Date',
      dataIndex: 'indentDate',
      align: 'left',
      width: 150,
      sorter: (a, b) => moment(a.indentDate).unix() - moment(b.indentDate).unix(),
      sortDirections: ['descend', 'ascend'],
      render: (text, record) => { return moment(record.indentDate).format('YYYY-MM-DD') },


      // ...getColumnSearchProps('indentDate')
    },
    {
      title: 'Indent Number',
      dataIndex: 'indentNo',
      width: 140,
      align: 'left',
      sorter: (a, b) => a.indentNo.localeCompare(b.indentNo),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('indentNo')
    },
    // {
    //   title: 'Sale Person',
    //   dataIndex: ["salePersonInfo","employeeName"],
    //   align:'left',
    //   sorter: (a, b) => a.salePersonInfo.employeeName.localeCompare(b.salePersonInfo.employeeName),
    //   sortDirections: ['descend', 'ascend'],
    //   // ...getColumnSearchProps('salePerson')
    // },

    // {
    //   title: 'Status',
    //   dataIndex: 'status',
    //   align:'left',
    //   render: (status, rowData) => (
    //     <>
    //       {status?<Tag icon={<CheckCircleOutlined />} color="#87d068">{status}</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">{status}</Tag>}

    //     </>
    //   ),
    //   filters: [
    //     {
    //       text: 'OPEN',
    //       value: 'OPEN',
    //     },
    //     {
    //       text: 'RETURNED',
    //       value: 'RETURNED',
    //     },
    //   ],
    //   filterMultiple: false,
    //   onFilter: (value, record) => 
    //   {
    //     // === is not work
    //     console.log(value);
    //     return record.status === value;
    //   },

    // },
    // {
    //   title:`Action`,
    //   dataIndex: 'action',
    //   align:'left',
    //   render: (text, rowData) => (
    //     <span>   
    //       {(storeConsumptionId) ? <Redirect to={{pathname:"/store-consumption-detail-view", state:storeConsumptionId}}/>:null}      
    //         <EyeOutlined  className={'viewSamplTypeIcon'}  type="view" 
    //         onClick={() => gotToStoreIssuesDetailView(rowData)}
    //           style={{ color: '#1890ff', fontSize: '14px' }}
    //         />

    // //     </span>
    //   )
    // }
  ];

  const cancelledAction: ColumnProps<any>[] = [
    {
      title: 'Action',
      key: 'action',
      render: (text, rowData, index) => <Button type="primary" onClick={() => storeReturn(rowData)} danger icon={<SnippetsOutlined />}>Return to Bulk</Button>
    },
  ];

  const storeReturn = (rowData) => {
    getStoreItems(rowData.saleOrderId, rowData.storeConsumptionId);
  }

  const getStoreItems = (saleOrderId, storeConsumptionId) => {
    storeConsumptionService.getStoreConsumptionItemsById({ saleOrderId: 0, storeConsumptionId: storeConsumptionId }).then(res => {
      if (res.status) {
        const itemId = res.data[0].itemId;
        setReturnData({ itemId, saleOrderId })
        setRedirectToReturn(true);
      } else {
      }
    }).catch(err => {
    })
  }
  /**
   * 
   * @param pagination 
   * @param filters 
   * @param sorter 
   * @param extra 
   */
  const onChange = (pagination, filters, sorter, extra) => {
    console.log("TESTING");
  }



  const renderItems = (record: GetStoreConsumptionItemsDto, index, indent, expanded) => {
    return <StoreConsumptions storeConsumptionId={record.storeConsumptionId} />
  }

  return (
    <>
      {(redirectToReturn) ? <Redirect to={{ pathname: "/store-return-form", state: { returnData } }} /> : null}
      <Card title={<span style={{ color: 'white' }}>Store Issues</span>}
        style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={((JSON.parse(localStorage.getItem('role'))) !== EmployeeRolesEnum.HO_PACKAGING_MANAGER) ? <Link to='/store-consumption-form' ><Button className='panel_button' >Create </Button></Link> : <></>}

      >
        <br></br>
        <Row gutter={24} >
          <Col>
            <Card title={'TOTAL STORE ISSUES: ' + storeConsumptionData.length} style={{ textAlign: 'left', width: 250, height: 41, backgroundColor: '#bfbfbf' }}></Card>
          </Col>
          {/* <Col>
            <Card title={StoreConsumptionStatus.Open + ' :' + (storeConsumptionData.filter(el => el.status == StoreConsumptionStatus.Open)).length} style={{ textAlign: 'left', height: 41, backgroundColor: '#f6e552' }}></Card>
          </Col> */}
          <Col>
            <Card title={StoreConsumptionStatus.Partially_Returned + ' :' + (storeConsumptionData.filter(el => el.status == StoreConsumptionStatus.Partially_Returned)).length} style={{ textAlign: 'left', height: 41, backgroundColor: '#f2a637' }}></Card>
          </Col>
          <Col>
            <Card title={StoreConsumptionStatus.Returned + ' :' + (storeConsumptionData.filter(el => el.status == StoreConsumptionStatus.Returned)).length} style={{ textAlign: 'left', height: 41, backgroundColor: 'rgb(135, 208, 104)' }}></Card>
          </Col>
        </Row>
        <br></br>

        <Tabs type={'card'} tabPosition={'top'}>
          <TabPane
            key="1"
            tab={<span style={{ color: "#f5222d" }}>{"Consumptions :" + storeConsumptionData.length}</span>}
          >
            <Table
              rowKey={record => record.storeConsumptionId}
              columns={columnsSkelton}
              dataSource={storeConsumptionData}
              expandedRowRender={renderItems}
              expandIconColumnIndex={8}
              pagination={{
                onChange(current) {
                  setPage(current);
                }
              }}
              onChange={onChange}
              scroll={{ x: 500 }}
              size="large"
              bordered

            >
            </Table>
          </TabPane>
          <TabPane
            key="2"
            tab={<span style={{ color: "#f5222d" }}>{"Cancelled SO's :" + cancelledSoConsumptions.length}</span>}
          >
            <Table
              rowKey={record => record.storeConsumptionId}
              columns={[...columnsSkelton, ...cancelledAction]}
              dataSource={cancelledSoConsumptions}
              expandedRowRender={renderItems}
              expandIconColumnIndex={8}
              pagination={{
                onChange(current) {
                  setPage(current);
                }
              }}
              onChange={onChange}
              scroll={{ x: 500 }}
              size="large"
              bordered

            >
            </Table>
          </TabPane>
          <TabPane
            key="3"
            tab={<span style={{ color: "#f5222d" }}>{"Revised SO's :" + revisedSoConsumptions.length}</span>}
          >
            <Table
              rowKey={record => record.storeConsumptionId}
              columns={[...columnsSkelton, ...cancelledAction]}
              dataSource={revisedSoConsumptions}
              expandedRowRender={renderItems}
              expandIconColumnIndex={8}
              pagination={{
                onChange(current) {
                  setPage(current);
                }
              }}
              onChange={onChange}
              scroll={{ x: 500 }}
              size="large"
              bordered

            >
            </Table>
          </TabPane>

        </Tabs>


      </Card>
    </>
  );
}

export default StoreConsumptionGrid;
